<div class="text-center gif-success">
  <img src="/assets/images/success.gif" alt="" />
  <h6>An Email with attachment has been sent to you.</h6>
  <h6>Kindly wait for a few minutes for the mail to be delivered.</h6>
  <h6 *ngIf="isCoEListRoute" class="text-danger">
    Document URL mentioned in the export is valid for "72" hours
  </h6>
  <button class="save-excel mt-2" (click)="Success()">Ok</button>
</div>
